// Libraries
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Observable } from 'rxjs';

/**
 * `PaginationComponent` implements a view for manage a list with pagination.
 */
@Component({
  selector: 'wp-pagination',
  template: require('./pagination.component.html'),
  styles: [require('./pagination.component.scss')]
})
export class PaginationComponent implements OnInit, OnChanges {
  /**
   * Current page.
   */
  @Input() currentPage = 1;
  /**
   * Per page.
   */
  @Input() perPage = 10;
  /**
   * Total count.
   */
  @Input() totalCount = 0;
  /**
   * Count for page buttons.
   */
  @Input() range = 1;
  /**
   * Page change event.
   */
  @Output() public pageChange: EventEmitter<number> = new EventEmitter<number>();
  /**
   * Current page list
   */
  public pages: Observable<number[]>;
  /**
   * Current total pages
   */
  public totalPages: number;
  /**
   * Saved total count
   */
  protected savedTotalCount: number;

  /**
   * Creates a new `PaginationComponent` instance.
   */
  constructor(
  ) { }

  /**
   * On init method, generate all pages
   */
  public ngOnInit(): void {
    // Generate pages
    this.generatePages();
  }

  /**
   * On changes method, generate all pages
   */
  public ngOnChanges(): void {
    // Generate pages
    this.generatePages();
  }

  /**
   * Generate pages array based on attributes.
   */
  public generatePages(): void {
    // Calculate total pages and page array list
    this.totalPages = this.getTotalPages(this.perPage, this.totalCount);
    this.pages = Observable.range(-this.range, this.range * 2 + 1)
      .map(currentOffset => {
        return this.currentPage + currentOffset;
      })
      .filter(page => this.isValidPageNumber(page, this.totalPages))
      .toArray();
    // Save total count
    this.savedTotalCount = this.totalCount;
  }

  /**
   * Check if page number is valid.
   * @param page Page numer to check
   * @param totalPages Total pages
   * @returns TRUE If page is available.
   */
  public isValidPageNumber(page: number, totalPages: number): boolean {
    return page > 0 && page <= totalPages;
  }

  /**
   * Returns the number of total pages.
   * @param perPage Page limit
   * @param totalCount Total count
   * @returns Total pages number.
   */
  public getTotalPages(perPage: number, totalCount: number): number {
    return Math.ceil(Math.max(totalCount, 1) / Math.max(perPage, 1));
  }

  /**
   * Select one page.
   * @param page Page number to select
   * @param event Current event
   */
  public selectPage(page: number, event): void {
    this.cancelEvent(event);
    // Check if page is valid
    if (this.isValidPageNumber(page, this.totalPages)) {
      // Emit event
      this.pageChange.emit(page);
    }
  }

  /**
   * Prevent current event.
   * @param event Current event
   */
  public cancelEvent(event): void {
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/pagination/pagination.component.ts